export enum CreditsActionType {
  ADD = 'ADD',
  CONSUME = 'CONSUME',
  RESERVE = 'RESERVE',
  RELEASE_RESERVATION = 'RELEASE_RESERVATION',
  RESET = 'RESET',
}
